import { render } from "./pointUseList.vue?vue&type=template&id=1756a778&scoped=true"
import script from "./pointUseList.vue?vue&type=script&lang=js"
export * from "./pointUseList.vue?vue&type=script&lang=js"

import "./pointUseList.vue?vue&type=style&index=0&id=1756a778&scoped=true&lang=css"
import "@/styles/striNew.css?vue&type=style&index=1&lang=css"
import "./pointUseList.vue?vue&type=style&index=2&id=1756a778&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1756a778"]])

export default __exports__